import React from 'react';
import PropTypes from 'prop-types';
import includes from 'lodash/fp/includes';

import { CustomPropTypes, RoomCard } from '../../../common';
import FormSubmit from '../FormSubmit';
import PrivateInformation from '../PrivateInformation';
import ProfileInformation from '../ProfileInformation';
import RecurringInformation from '../RecurringInformation';

import { RoomNameAndType } from '../NameAndType';
import RoomCapacityAndTime from '../RoomCapacityAndTime';

const width = amount => ({ width: amount });

function BookingRoomCardTabletAndDesktop(props) {
  const {
    booking,
    selected,
    style,
    onOpenOccurrence,
    onOpenMaster,
    isProfile3,
    isProfile2
  } = props;
  const { resource, isPrivate, isRecurring, roomMeetingResponseType } = booking;

  const renderPrivateInformation = () => {
    if (!isPrivate || selected) {
      return null;
    }
    return (
      <div className="BookingCard__Information" key="Private">
        <PrivateInformation />
      </div>
    );
  };

  const renderRoomNameAndType = () => {
    if (selected) {
      return null;
    }

    return [
      <div style={width('50%')} key="RoomNameAndType">
        <RoomNameAndType room={booking.resource} />
      </div>,
      <div style={width('50%')} key="RoomCapacityAndTime">
        <RoomCapacityAndTime booking={booking} />
      </div>
    ];
  };

  const renderFormSubmit = () => {
    if (!selected) {
      return null;
    }
    return (
      <div style={width('100%')} key="FormSubmit">
        <FormSubmit openDetailView={onOpenOccurrence} openMasterView={onOpenMaster} />
      </div>
    );
  };

  const renderProfileInformation = () => {
    if (selected || !(isProfile2 || isProfile3)) {
      return null;
    }

    return (
      <div className="BookingCard__Information" key="Profile">
        <ProfileInformation resource={resource} responseType={roomMeetingResponseType} />
      </div>
    );
  };

  const renderRecurringInformation = () => {
    if (selected || !isRecurring) {
      return null;
    }
    return (
      <div className="BookingCard__Information" key="Recurring">
        <RecurringInformation />
      </div>
    );
  };

  const onCardClick = () => {
    const isBookedForMe = !includes('Owner', booking.permissionTypes);

    if (!isRecurring || isBookedForMe) {
      onOpenOccurrence();
    }
  };

  return (
    <RoomCard resourceSubType={resource.resourceSubType} onClick={onCardClick} style={style}>
      {renderRoomNameAndType()}
      {renderPrivateInformation()}
      {renderRecurringInformation()}
      {renderProfileInformation()}
      {renderFormSubmit()}
    </RoomCard>
  );
}

BookingRoomCardTabletAndDesktop.propTypes = {
  booking: CustomPropTypes.booking,
  selected: PropTypes.bool.isRequired,
  style: PropTypes.shape(),
  onOpenOccurrence: PropTypes.func.isRequired,
  onOpenMaster: PropTypes.func.isRequired,
  isProfile3: PropTypes.bool.isRequired,
  isProfile2: PropTypes.bool.isRequired
};

export default BookingRoomCardTabletAndDesktop;
